import axios from 'axios';
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import httpClient from '../../httpClient';

class DiscussRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            friendUser : null,
            lastMsg : null
        }
    }
    conversation = this.props.conversation
    user = this.props.currentUser
    
    
    getLastMessage = async()=>{
        const host  = process.env.REACT_APP_SERVER_URL
        const res = await axios.get(`${host}/api/messages/${this.conversation._id}`)
    
        this.setState({lastMsg : res.data[res.data.length-1].message}) 
        
    }

    getUser =  () =>{
      let friendId = this.conversation.members.find((m)=> m !== this.user._id)
      httpClient.getUser(friendId).then(
          res => {
          
             
                this.setState({friendUser : res.name})
        
          }
      )
    }
    componentDidMount (){
        this.getUser()
        this.getLastMessage()
        console.log(this.state.lastMsg);
       
    }
    render() {
        return (
            <>
            <NavLink to={{
                pathname:"/messagerie/"+this.conversation._id,
                state: {convId : this.conversation._id, friendName : this.state.friendUser, conversation : this.conversation}
            }}>

            <div className="discussRow d-flex justify-content-between mb-2 ">
                     <div className="d-flex align-items-center">
                        <input className="conv__check" type="checkbox" name="discuss" id="discuss" />
                        {this.props.admin ?  <img src="/imgs/dash/admin_circle.svg" className="conv__circle" alt="" />:<img src="/imgs/dash/conv_circle.svg" className="conv__circle" alt="" />}
                       
                        <div className="conv__txt d-flex flex-column">
                            <span className="conv__profile">{this.state.friendUser}</span>
                            <span className="conv__msg">
                               { this.state.lastMsg?.includes("/api") ? <span>Photo</span> :this.state.lastMsg}
                            </span>
                        </div>
                     </div>
                     <div className="conv__actions d-flex align-items-center">
                      <img src="/imgs/dash/return.svg" className="mt-2" id="return__msg" alt="" />
                      <img src="/imgs/dash/opened.svg" className="msg__actions ml-3 mt-1" alt="" />
                      {!this.props.admin && (
                          <>
                        <img src="/imgs/dash/times.svg" className="msg__actions ml-3" alt="" />
                        <img src="/imgs/dash/archive_do.svg" className="msg__actions ml-3 mt-1" alt="" />
                        </>
                      ) }
                      
                    </div>
            </div>
            <hr/>
            </NavLink>
            </>
        );
    }
}

export default DiscussRow;
